(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fbp-apparel-carousel"] && !Shopify.designMode) return;
  try {
    
  // Fur Babies Plus — tiny autoplay carousel: slides one product at a time, loops, pauses on
  // hover / focus / hidden tab, respects reduced motion, dots rebuilt per breakpoint.
  if (!customElements.get('fbp-carousel')) {
    class FbpCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.fbp-apparel__track');
        this.slides = Array.from(this.querySelectorAll('.fbp-apparel__slide'));
        this.prev = this.querySelector('.fbp-apparel__arrow--prev');
        this.next = this.querySelector('.fbp-apparel__arrow--next');
        this.dots = this.querySelector('.fbp-apparel__dots');
        this.index = 0;
        this.interval = parseInt(this.dataset.interval, 10) || 5000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.auto = this.hasAttribute('data-autoplay') && !this.reduced;

        this.prev.addEventListener('click', () => this.go(this.index - 1, true));
        this.next.addEventListener('click', () => this.go(this.index + 1, true));
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { this.go(this.index - 1, true); }
          if (e.key === 'ArrowRight') { this.go(this.index + 1, true); }
        });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.play());
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.play()));

        // basic swipe
        let x0 = null;
        this.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
        this.addEventListener('pointerup', (e) => {
          if (x0 === null) return;
          const dx = e.clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
        });

        let t;
        window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(() => this.layout(), 120); });
        this.layout();
        this.play();

        // Drop the white studio background from each tee photo (Shopify's CDN sends CORS headers,
        // so the canvas stays readable). If anything fails the original image is shown as is.
        this.classList.add('is-keying');
        this.querySelectorAll('.fbp-apparel__slide img').forEach((img) => {
          const run = () => this.keyOut(img);
          if (img.complete && img.naturalWidth) run(); else { img.addEventListener('load', run, { once: true }); img.addEventListener('error', () => img.classList.add('is-ready'), { once: true }); }
        });
      }
      keyOut(img) {
        try {
          const w = Math.min(img.naturalWidth, 800), h = Math.round(img.naturalHeight * w / img.naturalWidth);
          const c = document.createElement('canvas'); c.width = w; c.height = h;
          const ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, w, h);
          const d = ctx.getImageData(0, 0, w, h), px = d.data;
          // Flood-fill the near-white background in from the corners, so a white tee (which is
          // enclosed by its own soft edge) keeps its body while the studio backdrop goes.
          const n = w * h, bg = new Uint8Array(n), stack = [0, w - 1, n - w, n - 1];
          const light = (k) => Math.min(px[k * 4], px[k * 4 + 1], px[k * 4 + 2]) >= 248;
          for (const s of stack) bg[s] = 1;
          while (stack.length) {
            const k = stack.pop(), x = k % w;
            const nb = [k - w, k + w, x > 0 ? k - 1 : -1, x < w - 1 ? k + 1 : -1];
            for (const j of nb) if (j >= 0 && j < n && !bg[j] && light(j)) { bg[j] = 1; stack.push(j); }
          }
          for (let k = 0; k < n; k++) {
            if (bg[k]) { px[k * 4 + 3] = 0; continue; }
            const x = k % w, m = Math.min(px[k * 4], px[k * 4 + 1], px[k * 4 + 2]);
            if (m > 226 && ((k >= w && bg[k - w]) || (k + w < n && bg[k + w]) || (x > 0 && bg[k - 1]) || (x < w - 1 && bg[k + 1]))) {
              px[k * 4 + 3] = Math.round(px[k * 4 + 3] * (248 - m) / 22); // soften the outline
            }
          }
          ctx.putImageData(d, 0, 0);
          img.removeAttribute('srcset'); img.removeAttribute('sizes');
          img.src = c.toDataURL('image/png');
        } catch (e) { /* tainted canvas or unsupported: keep the plain image */ }
        img.classList.add('is-ready');
      }
      perView() {
        return Math.max(1, parseInt(getComputedStyle(this.closest('.fbp-apparel') || this).getPropertyValue('--pv'), 10) || 1);
      }
      positions() {
        return Math.max(1, this.slides.length - this.perView() + 1);
      }
      layout() {
        const n = this.positions();
        if (this.index > n - 1) this.index = n - 1;
        this.prev.hidden = this.next.hidden = n < 2;
        this.dots.innerHTML = '';
        if (n > 1) {
          for (let i = 0; i < n; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'fbp-apparel__dot';
            b.setAttribute('role', 'tab');
            b.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + n);
            b.addEventListener('click', () => this.go(i, true));
            this.dots.appendChild(b);
          }
        }
        this.go(this.index, false, true);
      }
      go(i, user, instant) {
        const n = this.positions();
        this.index = ((i % n) + n) % n;
        this.track.style.transitionDuration = instant ? '0ms' : '';
        this.track.style.transform = 'translateX(' + (-this.index * 100 / this.perView()) + '%)';
        Array.from(this.dots.children).forEach((d, k) => d.setAttribute('aria-current', k === this.index ? 'true' : 'false'));
        if (user) this.play(); // restart the timer after a manual move
      }
      play() {
        this.stop();
        if (!this.auto || this.positions() < 2) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }
      stop() {
        clearInterval(this.timer);
      }
    }
    customElements.define('fbp-carousel', FbpCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
